import { SeleccionProducto } from './seleccion-producto.class';
import { RedireccionMenu } from './redireccion-menu.class';
import { DetalleOpcion } from './detalle-opcion.class';

export class MenuItem {

    cdresource: number;
    order: number;
    name: String;
    contextPath: String;
    target: String;
    windowOptions: String;
    image: String;
    children: MenuItem[];
    styleClass: String;
    imageLocal: String;
    seleccionProducto: SeleccionProducto;
    redireccionMenu: RedireccionMenu;
    detalleOpcion: DetalleOpcion;
    isStatic: boolean;
 

    constructor(cdresource: number, order: number, name: String,
        contextPath: String, imageLocal: String, children: MenuItem[],
        styleClass: String, isStatic: boolean, redireccionMenu?: RedireccionMenu, windowOptions: String = null, target: String = null) {
        this.cdresource = cdresource;
        this.order = order;
        this.name = name;
        this.contextPath = contextPath;
        this.imageLocal = imageLocal;
        this.children = children;
        this.styleClass = styleClass;
        this.imageLocal = imageLocal;
        this.seleccionProducto = null;
        this.redireccionMenu = redireccionMenu !== undefined ? redireccionMenu : null;
        this.target = target;
        this.windowOptions = windowOptions;
        this.isStatic = isStatic;
    }


}



// WEBPACK FOOTER //
// ./src/app/models/menu/menu-item.class.ts